import { Button }                 from "@/components/ui/button";
import { Center }                 from "@chakra-ui/react";
import { Field }                  from "@/components/ui/field";
import { Input }                  from "@chakra-ui/react";
import { SelectContent }          from "@/components/ui/select";
import { SelectItem }             from "@/components/ui/select";
import { SelectRoot }             from "@/components/ui/select";
import { SelectTrigger }          from "@/components/ui/select";
import { SelectValueText }        from "@/components/ui/select";
import { Spinner }                from "@chakra-ui/react";
import { Stack }                  from "@chakra-ui/react";
import { Text }                   from "@chakra-ui/react";
import _capitalize                from "lodash/capitalize";
import authStore                  from "@/stores/authStore";
import { createListCollection }   from "@chakra-ui/react";
import { toaster }                from '@/components/ui/toaster';
import { useForm }                from "react-hook-form";
import { useTranslation }         from "react-i18next";

interface FormValues {
	firstName: string;
	lastName: string;
	gender: string;
}

const PersonalInformationForm = () => {
	const { t } = useTranslation();
	const currentUser = authStore.currentUser;

	const genders = createListCollection({
		items: [
		  { label: _capitalize(t('app.selects.genders.man')), value: '1' },
		  { label: _capitalize(t('app.selects.genders.woman')), value: '2' },
		],
	});

	const {
        formState: { errors, isSubmitting },
        handleSubmit,
		setValue,
        register,
    } = useForm<FormValues>({
		defaultValues: {
			firstName: currentUser.firstName,
			lastName: currentUser.lastName,
			gender: String(currentUser.gender),
		},
	})

	const onSubmit = handleSubmit(async (data) => {
		const { firstName, gender, lastName } = data;
        try {

			await currentUser.patch({
				firstName: firstName,
				lastName: lastName,
				gender: parseInt(gender),
			});

			toaster.create({
                title: t('pages.personalInformation.personalInformationBox.form.messages.success'),
                type: 'success'
            });
        } catch (error) {
			toaster.create({
                title: t('pages.personalInformation.personalInformationBox.form.messages.errors.error'),
                type: 'error'
            });
            console.log(error);
        }
    })

	if (isSubmitting) {
		return (
			<Center height="100%" >
				<Spinner borderWidth="4px" size="xl" />
			</Center>
		)
	}

	return (
		<form onSubmit={onSubmit}>
			<Stack gap="20px">
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>{
							t('pages.personalInformation.personalInformationBox.form.lastName')}
						</Text>
					}
					invalid={!!errors.lastName}
					required
				>
					<Input
						defaultValue={currentUser.lastName}
						placeholder={t('pages.personalInformation.personalInformationBox.form.lastName')}
						{...register("lastName", { required: true })}
					/>
				</Field>
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>{
							t('pages.personalInformation.personalInformationBox.form.firstName')}
						</Text>
					}
					invalid={!!errors.firstName}
					required
				>
					<Input
						defaultValue={currentUser.firstName}
						placeholder={t('pages.personalInformation.personalInformationBox.form.firstName')}
						{...register("firstName", { required: true })}
					/>
				</Field>
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>{
							t('pages.personalInformation.personalInformationBox.form.genders.label')}
						</Text>
					}
					required
				>
					<SelectRoot
						collection={genders}
						defaultValue={[String(currentUser.gender)]}
						onValueChange={v => setValue('gender', v.value[0])}
					>
						<SelectTrigger cursor="pointer">
							<SelectValueText placeholder={t('pages.personalInformation.personalInformationBox.form.genders.label')} />
						</SelectTrigger>
						<SelectContent>
							{genders.items.map((gender) => (
								<SelectItem 
									cursor="pointer"
									item={gender} 
									key={gender.value}
									_hover={{ backgroundColor: '#DEDEDE' }}
								>
									{gender.label}
								</SelectItem>
							))}
						</SelectContent>
					</SelectRoot>
				</Field>

				<Button 
					variant="solid" 
					type="submit" 
					width="100%"
					marginTop="20px"
					loading={isSubmitting}
				>
					{t('pages.personalInformation.personalInformationBox.form.actions.save')}
				</Button>
			</Stack>
		</form>
	)
}

export default PersonalInformationForm;